export default __webpack_public_path__ + "media/comment.93f7ebc9.svg";